import { ArrowDown2 } from 'iconsax-react';
import { type Dispatch, type SetStateAction, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useClickAnyWhere } from 'usehooks-ts';
import { type SessionFilterType, sessionFilterOptions } from '@/hooks/sessions/use-conversation-sessions';
import cn from '@/utils/merge-class-names';

type FilterSessionDropdownProps = {
  filter: SessionFilterType;
  setFilter: Dispatch<SetStateAction<SessionFilterType>>;
  onChange: (filter: SessionFilterType) => void;
};

export default function FilterSessionDropdown({ filter, setFilter, onChange }: FilterSessionDropdownProps) {
  const { t } = useTranslation();
  const dropdownRef = useRef<HTMLDetailsElement>(null);

  const handleUpdateSortBy = (value: SessionFilterType) => {
    setFilter((prev) => {
      if (prev !== value) {
        onChange(value);
      }
      return value;
    });

    if (dropdownRef.current) dropdownRef.current.open = false;
  };

  useClickAnyWhere(() => {
    if (dropdownRef.current && !dropdownRef.current.contains(document.activeElement)) {
      dropdownRef.current.open = false;
    }
  });

  return (
    <details
      ref={dropdownRef}
      className='dropdown dropdown-end dropdown-bottom select-none'>
      <summary className='flex items-center justify-between text-secondary'>
        <span className='pr-0.5 text-body2'>
          {t(sessionFilterOptions.find(({ value }) => value === filter)?.label ?? '')}
        </span>
        <ArrowDown2
          variant='Bold'
          size={8}
        />
      </summary>
      <ul className='menu dropdown-content z-50 mt-1 w-24 rounded-lg bg-neutral-0 p-2 shadow'>
        {sessionFilterOptions.map(({ value, label }) => (
          <li
            key={value}
            className={cn('px-4 py-2 text-center text-body1 rounded', {
              'bg-neutral-100': value === filter,
            })}
            onClick={() => handleUpdateSortBy(value)}>
            {t(label)}
          </li>
        ))}
      </ul>
    </details>
  );
}
